import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense, useEffect, useMemo, useRef, useState } from "react";
import { createHostMicroFrontendManager } from "../microfrontend/managers/hostMicroFrontend";
import { MF_EVENTS, } from "../microfrontend/interfaces/microFrontend";
import { v4 as uuidv4 } from "uuid";
import { useHostMicroFrontendApi } from "../microfrontend/hooks/useHostMicroFrontend";
import useToastStore from "../zustand/toastStore";
import { HOST_MODES } from "@/constants";
import ChatInterface from "@/widgets/chat/components/ChatInterface";
import ModeSwitcher from "@/components/ModeSwitcher";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/mdc-light-indigo/theme.css";
import { convertMessagesToChatMessages, isHostMode, } from "../utils/helpers";
import { useLocation, useNavigate, useParams, useSearchParams, } from "react-router-dom";
import useAuthStore from "../zustand/authStore";
import useProjectStore from "../zustand/projectManagementStore";
import { Button } from "primereact/button";
import { ProjectBreadcrumbs } from "@/widgets/projectCreation/components/ProjectBreadCrumbs";
import MainLayout from "./MainLayout";
import LoadingAnimationHands from "@/assets/animations/loadingAnimationHands.json";
if (!window.hostMicroFrontendApi) {
    window.hostMicroFrontendApi = createHostMicroFrontendManager();
}
import { useMainLayoutStore } from "../zustand/mainLayoutStore";
import { Maximize2, MessageCirclePlus, MessageSquareShare, Minimize2, } from "lucide-react";
import clsx from "clsx";
import ProjectSelectionDialog from "@/widgets/projectCreation/components/ProjectSelectionDialog";
import { getModes, initializeChat, updateArtifactIdInUrl, updateUrlWithParams, } from "../utils/appLayoutUtils/appLayoutUtilities";
import { processMessage } from "../utils/appLayoutUtils/applLayoutServices";
import { useMFCommunication } from "../utils/appLayoutUtils/useMFCommunication";
import { Tooltip } from "primereact/tooltip";
import { checkUserInAgentSpace, grantViewerAccess, uploadChatHistory } from "@/core/api/api";
import ModeSwitcherErrorBoundary from "@/components/ModeSwitcherErrorBoundary";
import Lottie from "react-lottie-player";
import AccessDeniedDialog from "@/widgets/projectCreation/components/AccessDeniedDialog";
import InvalidProjectDialog from "@/components/InvalidProjectDialog";
function AppLayout() {
    // console.log("modesHistory", modesHistory);
    const navigate = useNavigate();
    const { chatId } = useParams();
    const location = useLocation();
    const chatIdRef = useRef(undefined);
    const panelRef = useRef(null);
    const modeSideRef = useRef(null);
    const { selectedProject } = useProjectStore();
    const { user, isLoggedIn, onboardingStep, setOnboardingStep } = useAuthStore();
    const showToast = useToastStore((state) => state.showToast);
    const { streamingMessages, modeFullScreen, setModeFullScreen, showChatInterface, currentHostMode, modesHistory, activeMode, modeList, isWidgetTypeChange, isCurrentHostChanged, isUserOnboarded, remoteLoadedInfo, hostLoadedInfo, pendingArtifactData, pendingArtifactDataFromHost, modeNameToAssistantName, sidebarType, recentConversations, setShowChatInterface, setModesHistory, setCurrentHostMode, setShowModeOnboarding, setActiveMode, setModeList, setSidebarType, setRecentConversations, setIsWidgetTypeChange, setIsCurrentHostChanged, setIsUserOnboarded, setRemoteLoadedInfo, setHostLoadedInfo, setPendingArtifactData, setPendingArtifactDataFromHost, setStreamingMessages,
    // setModeNameToAssistantName,
     } = useMainLayoutStore();
    const mfApi = useHostMicroFrontendApi();
    const [rendordone, setRenderDone] = useState(true);
    const [responseMessages, setResponseMessage] = useState([]);
    const [messageLoading, setMessageLoading] = useState(false); //here
    const [waitMessageLoading, setWaitMessageLoading] = useState(false);
    const [replyMessage, setReplyMessage] = useState("");
    const [sessionId, setSessionId] = useState(`chat-session-${uuidv4()}`);
    // const [activeStep, setActiveStep] = useState(0); // For Landing Section // mainlayout
    const [initLoading, setInitLoading] = useState(true);
    // const [streamingMessages, setStreamingMessages] = useState<
    //   StreamingMessageType[]
    // >([]); // moved to zustand
    const [showProjectSelectionDialog, setShowProjectSelectionDialog] = useState(false);
    const [msgDataArtifact, setMsgDataArtifact] = useState(null);
    useEffect(() => {
        setStreamingMessages([
            {
                role: "assistant",
                content: isUserOnboarded
                    ? `Hey ${user?.provider?.name ?? ""}, I am Creative Workspace AI, and I am here to help you with anything on our platform. What would you like to do today?`
                    : `Hey ${user?.provider?.name ?? ""} , welcome to Creative Workspace! Let's help you get started. Please Complete the onbaording on the right, so we can assist you better! Feel free to ask me any questions that you have`,
                time: new Date(),
            },
        ]);
    }, [isUserOnboarded]);
    // Auto create new chat
    useEffect(() => {
        const createNewChatAutomatically = async () => {
            const currentPathName = window.location.pathname;
            // console.log("printing currentPathName", currentPathName);
            // double check :)
            if (currentPathName === "/chat" || currentPathName === "/chat/") {
                const newChatId = uuidv4();
                chatIdRef.current = newChatId; // Set ref immediately when generating new ID
                try {
                    // Include project ID in URL if it exists
                    const urlParams = new URLSearchParams();
                    if (selectedProject?._id) {
                        urlParams.set("projectId", selectedProject._id);
                    }
                    const baseUrl = `/chat/${newChatId}`;
                    const fullUrl = urlParams.toString()
                        ? `${baseUrl}?${urlParams.toString()}`
                        : baseUrl;
                    // console.log("printing the fullUrl", fullUrl);
                    await navigate(fullUrl);
                    if (user?.email) {
                        const { responseData, error } = await uploadChatHistory(newChatId, user?.email, streamingMessages);
                        if (error) {
                            console.error("Error in creating in new chat history for this newChatId", newChatId, error.errorObjData);
                            showToast("error", "Error", error.errorMessage); // commenting this for today
                            return;
                        }
                        else {
                            // console.log("Successfully created chat history", responseData);
                        }
                    }
                }
                catch (error) {
                    console.error("Error creating new chat:", error);
                    showToast("error", "Error", "Failed to create new chat");
                }
            }
        };
        // enough condition to create a new chat (here 2 is the default msgs which host is keeping; but still keeping 3) 
        // (NOTE: it can be changed in future based on the number of default msgs from host)
        // LATER : Should count the number of default msgs from host
        if (streamingMessages.length >= 2 && (window.location.pathname === "/chat" || window.location.pathname === "/chat/")) {
            createNewChatAutomatically();
        }
    }, [streamingMessages, location.pathname]);
    console.log("streamingMessages", streamingMessages);
    const [isStreaming, setIsStreaming] = useState(false);
    const [chatResize, setChatResize] = useState(false);
    const [persistedData, setPersistedData] = useState([]);
    const [persistInstantLearningData, setPersistInstantLearningData] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const [projectIdFromURL, setProjectIdFromURL] = useState("");
    const [projectAccess, setProjectAccess] = useState(null);
    const [invalidProject, setInvalidProject] = useState(null);
    // console.log("printing projectAccess", projectAccess);
    console.log("remoteLoadedInfo", remoteLoadedInfo);
    console.log("hostLoadedInfo", hostLoadedInfo);
    // Add useEffect to keep chatIdRef in sync with URL param
    useEffect(() => {
        if (chatId) {
            chatIdRef.current = chatId;
        }
        else if (location.pathname === "/chat" ||
            location.pathname === "/chat/") {
            chatIdRef.current = undefined;
        }
    }, [chatId, location.pathname]);
    // Effect to manage project ID in URL
    useEffect(() => {
        if (selectedProject && selectedProject._id) {
            const urlObject = new URL(window.location.href);
            const projectId = selectedProject?._id;
            const urlProjectId = urlObject.searchParams.get("projectId");
            // Only update URL if:
            // 1. There's an explicitly selected project (projectId exists), OR
            // 2. There was no projectId in the URL to begin with
            if (projectId || !urlProjectId) {
                updateUrlWithParams(chatId || chatIdRef.current, urlObject.searchParams, {
                    projectId: projectId || null,
                });
            }
        }
    }, [selectedProject, chatId, searchParams]);
    useEffect(() => {
        initializeChat({
            navigate,
            searchParams,
            setProjectIdFromURL,
            chatId,
            // setActiveStep,
            setOnboardingStep,
            chatIdRef,
            setStreamingMessages,
            triggerForArtifact,
            setInitLoading,
            setProjectAccess,
            setInvalidProject,
        });
    }, []);
    const handleStreamSend = async (userQuery) => {
        if (location.pathname === "/chat" || location.pathname === "/chat/") {
            const newChatId = uuidv4();
            chatIdRef.current = newChatId; // Set ref immediately when generating new ID
            try {
                // Include project ID in URL if it exists
                const urlParams = new URLSearchParams();
                if (selectedProject?._id) {
                    urlParams.set("projectId", selectedProject._id);
                }
                const baseUrl = `/chat/${newChatId}`;
                const fullUrl = urlParams.toString()
                    ? `${baseUrl}?${urlParams.toString()}`
                    : baseUrl;
                await navigate(fullUrl);
                await processMessage(userQuery, true, newChatId, sessionId, replyMessage, streamingMessages, chatId, chatIdRef, {
                    setReplyMessage,
                    setMessageLoading,
                    setWaitMessageLoading,
                    setIsStreaming,
                    setRenderDone,
                    setStreamingMessages,
                    setResponseMessage,
                }, triggerFeedback);
            }
            catch (error) {
                console.error("Error during chat initialization:", error.message);
                showToast("error", "Error", "Failed to initialize chat"); // commenting this for today
                const errorMessage = {
                    role: "assistant",
                    time: new Date(),
                    id: uuidv4(),
                    content: error.message,
                };
                setStreamingMessages((prevMessages) => [...prevMessages, errorMessage]);
            }
        }
        else {
            // Ensure chatIdRef is synchronized with URL param
            if (chatId && chatId !== chatIdRef.current) {
                chatIdRef.current = chatId;
            }
            await processMessage(userQuery, false, chatId, sessionId, replyMessage, streamingMessages, chatId, chatIdRef, {
                setReplyMessage,
                setMessageLoading,
                setWaitMessageLoading,
                setIsStreaming,
                setRenderDone,
                setStreamingMessages,
                setResponseMessage,
            }, triggerFeedback);
        }
    };
    const handleCloseModeOnboarding = async () => {
        try {
            setShowModeOnboarding(false);
            const resultList = await getModes();
            if (resultList && resultList.length > 0)
                setModeList(resultList);
        }
        catch (error) {
            showToast("error", "Error", "Failed to close mode onboarding");
            console.warn("Failed to close mode onboarding:", error);
        }
    };
    const triggerForPersist = (mode, project) => {
        // console.log("Active mode to be persisted:", mode);
        if (!project) {
            showToast("error", "Error", "Project not found");
            return;
        }
        const request = {
            projectId: project._id,
            storeId: uuidv4(),
            requestStatus: "initiated",
            modeName: mode,
        };
        if (!mfApi) {
            showToast("error", "Error", "MF API not found");
            return;
        }
        // Dispatch the GET_PROJECT_DATA event
        mfApi.dispatch(MF_EVENTS.GET_PROJECT_DATA, request);
        // Add to persistedData state
        setPersistedData((prev) => [
            ...prev,
            {
                projectId: request.projectId,
                storeId: request.storeId,
                requestStatus: request.requestStatus,
                modeName: request.modeName,
                project: project,
                data: null,
            },
        ]);
    };
    const triggerForArtifact = async (data, fromInitialize, fromHost) => {
        const lastMode = modesHistory[modesHistory.length - 1]?.mode;
        // console.log("lastMode in triggerForArtifact", lastMode, modesHistory);
        if (fromHost) {
            // Only set modes if not fromInitialize
            if (!fromInitialize) {
                setCurrentHostMode(data.modeName);
                setModesHistory((prev) => [
                    ...prev,
                    {
                        mode: data.modeName,
                        openedBy: `Artifact - ${data.modeName}`,
                    },
                ]);
            }
            if (!mfApi) {
                showToast("error", "Error", "MF API not found");
                return;
            }
            if (hostLoadedInfo?.modeName !== data.modeName ||
                (hostLoadedInfo.modeName === data.modeName && !hostLoadedInfo.isLoaded)) {
                console.log(`${data.modeName} Host not loaded yet, storing artifact data ; hostLoadedInfo`, hostLoadedInfo);
                setPendingArtifactDataFromHost(data);
                return;
            }
            mfApi.dispatch(MF_EVENTS.SEND_ARTIFACT_DATA, data);
            if (data) {
                updateArtifactIdInUrl(data, searchParams, setSearchParams);
            }
        }
        else {
            // Only set modes if not fromInitialize
            if (!fromInitialize) {
                setActiveMode(data.modeName);
                setModesHistory((prev) => [
                    ...prev,
                    {
                        mode: data.modeName,
                        openedBy: `Artifact - ${data.modeName}`,
                    },
                ]);
            }
            if (!mfApi) {
                showToast("error", "Error", "MF API not found");
                return;
            }
            if (remoteLoadedInfo?.modeName !== data.modeName ||
                (remoteLoadedInfo.modeName === data.modeName &&
                    !remoteLoadedInfo.isLoaded)) {
                console.log(`${data.modeName} Remote not loaded yet, storing artifact data; remoteLoadedInfo`, remoteLoadedInfo);
                setPendingArtifactData(data);
                return;
            }
            mfApi.dispatch(MF_EVENTS.SEND_ARTIFACT_DATA, data);
            if (data) {
                updateArtifactIdInUrl(data, searchParams, setSearchParams);
            }
        }
    };
    // this function (triggerForUploadLogo) is used by Image gen mode fo upload logo
    const triggerForOpenDialog = (data) => {
        if (!mfApi) {
            showToast("error", "Error", "MF API not found");
            return;
        }
        if (!remoteLoadedInfo?.isLoaded) {
            console.log("Remote not loaded yet, storing artifact data");
            return;
        }
        const messagePayload = {
            message: "",
            isUploadLogo: data.isUploadLogo,
            isTextPosition: data.is_caption_placement,
            is_select_spot: data.is_select_spot,
            fontData: data.fontData,
            messageId: `requestId-${uuidv4()}`,
            chatHistory: convertMessagesToChatMessages(streamingMessages),
        };
        mfApi.dispatch("OPEN_DIALOG", messagePayload);
    };
    const handleModeSelectFrom = (mode, by, isHost, isEmpty) => {
        if (isHost)
            setCurrentHostMode(mode);
        else
            setActiveMode(mode);
        if (isEmpty) {
            console.warn("there is an empty mode added by ", by);
        }
        setModesHistory((prev) => [
            ...prev,
            {
                mode: mode,
                openedBy: by,
            },
        ]);
    };
    const triggerFeedback = (feedbackData) => {
        // if(!feedbackData) {
        //   console.error("No feedback data provided");
        //   showToast("error", "Error", "No feedback data provided");
        //   return
        // }
        // console.log("Feedback data is ", feedbackData);
        if (mfApi) {
            console.log("Dispatching message payload from host to feedback sidebar:", MF_EVENTS.FEEDBACK_STATUS, feedbackData);
            mfApi.dispatch(MF_EVENTS.FEEDBACK_STATUS, feedbackData);
        }
    };
    const triggerInstantLearningToSidebar = (data) => {
        if (!data) {
            console.error("No instant learning data provided");
            showToast("error", "Error", "No instant learning data provided");
            return;
        }
        // console.log("Instant learning data is ", data);
        if (mfApi) {
            console.log("Dispatching message payload from host to instant learning sidebar:", MF_EVENTS.INSTANT_LEARNING_STATUS, data);
            mfApi.dispatch(MF_EVENTS.INSTANT_LEARNING_STATUS, data);
        }
    };
    const triggerInstantLearningToMode = () => {
        if (modesHistory.length > 0) {
            if (modesHistory[modesHistory.length - 1]?.mode) {
                const currentMode = modesHistory[modesHistory.length - 1].mode;
                // remote mode
                if (!isHostMode(currentMode)) {
                    const currentRemoteMode = currentMode;
                    if (remoteLoadedInfo.modeName === currentRemoteMode &&
                        remoteLoadedInfo.isLoaded) {
                        if (mfApi) {
                            // console.log("Triggering GET instant learning from host ");
                            const triggerGetPayload = {
                                id: uuidv4(),
                                modeName: currentRemoteMode,
                                requestStatus: "initiated",
                            };
                            mfApi.dispatch(MF_EVENTS.INSTANT_LEARNING_GET_TRIGGER, triggerGetPayload);
                            // shall open the instant learning sidebar here
                            // setSidebarType("instant-learning");
                            setSidebarType("feedback");
                        }
                    }
                    else {
                        showToast("warn", "Warn", "No Remote Mode is loaded yet");
                        return;
                    }
                }
                else {
                    // host mode
                    const currtHostMode = currentMode;
                    if (hostLoadedInfo.modeName === currtHostMode && hostLoadedInfo.isLoaded) {
                        if (mfApi) {
                            // console.log("Triggering GET instant learning from host ");
                            // const triggerGetPayload: InstantLearningGetRequest = {
                            //   id: uuidv4(),
                            //   modeName: currtHostMode,
                            //   requestStatus: "initiated",
                            // };
                            // mfApi.dispatch(
                            //   MF_EVENTS.INSTANT_LEARNING_GET_TRIGGER,
                            //   triggerGetPayload
                            // );
                            // shall open the instant learning sidebar here
                            // setSidebarType("instant-learning");
                            setSidebarType("feedback");
                        }
                    }
                    else {
                        showToast("warn", "Warn", "No Host Mode is loaded yet");
                        return;
                    }
                }
            }
        }
    };
    const handleAddThisProject = (msgData) => {
        if (msgData && msgData.artifactData)
            setMsgDataArtifact(msgData);
        setShowProjectSelectionDialog(true);
    };
    useEffect(() => {
        if (panelRef.current) {
            if (showChatInterface) {
                panelRef.current.resize(sidebarType || chatResize ? 20 : 30); // Adjust size based on sidebarType
            }
            else {
                panelRef.current.resize(0); // Hide when showChatInterface is false
            }
        }
    }, [showChatInterface, sidebarType, chatResize]);
    const toggleChatPanel = async () => {
        if (panelRef.current) {
            if (!showChatInterface) {
                await panelRef.current.resize(sidebarType || chatResize ? 20 : 30); // Expand panel
            }
            else {
                await panelRef.current.resize(0); // Collapse panel
            }
            setShowChatInterface(!showChatInterface);
        }
    };
    const shallShowbtns = useMemo(() => {
        if (modesHistory.length > 0) {
            if (modesHistory[modesHistory.length - 1]?.mode) {
                // return !Object.keys(HOST_MODES)?.includes(
                //   modesHistory[modesHistory.length - 1]?.mode
                // );
                const currentMode = modesHistory[modesHistory.length - 1]?.mode;
                const disallowedModes = [HOST_MODES["Project Mode"], HOST_MODES["Mode Onboarding"]];
                // Return true if current mode is NOT in the disallowed list
                return !disallowedModes.includes(currentMode);
            }
        }
        return false;
    }, [modesHistory]);
    useEffect(() => {
        const agentSpaceAccess = async (email) => {
            if (email) {
                const accessResData = await checkUserInAgentSpace(email);
                if (accessResData.error) {
                    // console.log("error in checking user in agent space", accessResData.error);
                    if ("status" in accessResData.error.errorObjData &&
                        accessResData.error.errorObjData.status === 404) {
                        console.log("user not in agent space");
                        // have to add this below api in the based upon the above api response
                        const resData = await grantViewerAccess(email);
                        if (resData.error) {
                            console.error("error in granting viewer access", resData.error);
                            showToast("error", "Error", "Error in granting viewer access, check console for more details.");
                        }
                        else {
                            if (resData.responseData) {
                                // console.log(
                                //   "viewer access granted",
                                //   resData.responseData
                                // );
                            }
                        }
                    }
                    // for other errors like 500
                    else {
                        console.error("error in checking user in agent space", accessResData.error);
                        showToast("error", "Error", "Error in checking user in agent space");
                    }
                }
                else if (!accessResData.responseData?.hasAccess) {
                    const resData = await grantViewerAccess(email);
                    if (resData.error) {
                        console.error("error in granting viewer access", resData.error);
                        showToast("error", "Error", "Error in granting viewer access, check console for more details.");
                    }
                }
            }
        };
        if (user && user.email)
            agentSpaceAccess(user.email);
    }, [user]);
    //** NOTE hook for communication between host and remote ; Communication includes messages & artifacts;
    useMFCommunication({
        mfApi,
        // streamingMessages,
        // setStreamingMessages,
        chatIdRef,
        updateArtifactIdInUrl,
        searchParams,
        setSearchParams,
        triggerFeedback,
        setChatResize,
        handleAddThisProject,
        setPersistInstantLearningData,
        triggerInstantLearningToSidebar,
        triggerForArtifact,
    });
    return (_jsxs(MainLayout, { triggerInstantLearningToMode: triggerInstantLearningToMode, shallShowInstantLearningBtn: shallShowbtns, children: [_jsx("div", { className: "w-full flex justify-between h-full overflow-visible gap-x-[0.5rem]", children: _jsx("div", { className: "flex flex-col items-start w-full h-full", children: _jsxs("div", { className: "flex flex-col w-full h-full md:flex-row gap-x-4 relative", children: [!showChatInterface && (_jsxs("span", { children: [_jsx(Button, { icon: _jsx(MessageSquareShare, { size: 20, color: "#000" }), onClick: toggleChatPanel, className: "maximizeChatButton w-11 h-11 flex justify-center items-center absolute bottom-3 left-3 z-10 bg-[#fff] border border-[#d1d5db] rounded-full" }, !showChatInterface ? "maximizeChatButton" : " "), _jsx(Tooltip, { target: ".maximizeChatButton", content: !showChatInterface ? "Maximize Chat" : "", position: "top" })] })), _jsxs(PanelGroup, { direction: "horizontal", className: "w-full h-full !overflow-visible", children: [_jsx(Panel, { ref: panelRef, minSize: showChatInterface ? 20 : 0, defaultSize: 30, id: "sidebar", order: 1, 
                                        // collapsible
                                        collapsedSize: sidebarType || chatResize ? 20 : !showChatInterface ? 0 : 30, className: clsx("overflow-visible relative transition-all duration-300 ease-in-out", // Smooth animation
                                        showChatInterface ? "w-[40%]" : "w-0", sidebarType && showChatInterface ? "w-[30%]" : "w-[40%]"), children: _jsxs("div", { className: "flex flex-col w-full h-full relative border-r border-[#E5E5E5]", children: [_jsxs("div", { className: "w-full flex justify-between items-center  py-3 px-5", children: [_jsx(ProjectBreadcrumbs, { setCurrentHostMode: setCurrentHostMode, setModesHistory: setModesHistory, modesHistory: modesHistory, project: selectedProject, projectIdFromURL: projectIdFromURL }), _jsxs("div", { className: "w-[105px] flex items-center flex-1 gap-x-4", children: [_jsx("div", { className: "h-9 border-l border-[#E5E5E5]" }), _jsx(Button, { "data-pr-tooltip": "New Chat", "data-pr-position": "top", className: "newChatBtn", "aria-label": "Start New Chat", onClick: () => (window.location.href = "/chat?newChat=true"), icon: _jsx(MessageCirclePlus, { size: 20, color: "#000" }) }), _jsx(Tooltip, { target: ".newChatBtn" }), _jsx(Button
                                                                // key={showChatInterface ? "minimize" : "maximize"}
                                                                , { "data-pr-tooltip": "Minimize Chat", "data-pr-position": "top", "aria-label": "Minimize Chat", icon: showChatInterface ? (_jsx(Minimize2, { size: 20, color: "#000" })) : (_jsx(Maximize2, { size: 20, color: "#000" })), onClick: toggleChatPanel, className: "toggleChatButton p-2 bg-[#fff]", rounded: true }), _jsx(Tooltip, { target: ".toggleChatButton" }, showChatInterface ? "minimize" : "maximize")] })] }), _jsx("div", { className: "flex-1 overflow-hidden", children: _jsx(ChatInterface, { onSendMessage: (message) => handleStreamSend(message), messages: streamingMessages, isStreaming: isStreaming || messageLoading, handleArtifact: triggerForArtifact, 
                                                        // added as a optional parameter for image gen mode
                                                        handleUploadData: triggerForOpenDialog, 
                                                        // toggleChatPanel={toggleChatPanel}
                                                        handleAddToProject: (msgData) => handleAddThisProject(msgData), initLoading: initLoading }) })] }) }), showChatInterface && (_jsx(PanelResizeHandle, { className: "flex items-center justify-center w-0", children: _jsx("div", { className: "z-10 flex items-center justify-center w-1 h-6 bg-gray-300 rounded" }) })), _jsx(Panel, { minSize: 50, order: 2, children: _jsx("div", { className: "w-full h-full max-w-full flex flex-col flex-1 !overflow-auto relative ", ref: modeSideRef, children: _jsx(ModeSwitcherErrorBoundary, { children: _jsx(Suspense, { fallback: _jsx("div", { className: "w-full h-full m-auto flex flex-col justify-center items-center p-6", children: _jsx(Lottie, { animationData: LoadingAnimationHands, loop: true, play: true, className: "w-full md:w-1/2 mx-auto" }) }), children: _jsx(ModeSwitcher, { loading: initLoading, 
                                                        // modesHistory={modesHistory}
                                                        // setIsHostLoaded={setIsHostLoaded}
                                                        setHostLoadedInfo: setHostLoadedInfo, addModeToHistory: handleModeSelectFrom, 
                                                        // currentHostMode={currentHostMode}
                                                        // setCurrentHostMode={setCurrentHostMode}
                                                        handleCloseModeOnboarding: handleCloseModeOnboarding, 
                                                        // modeList={modeList}
                                                        // activeMode={activeMode}
                                                        setRemoteLoadedInfo: setRemoteLoadedInfo, 
                                                        // Moved add to project in app layout (this file)
                                                        // onAddProject={triggerForPersist}
                                                        hasProject: Boolean(selectedProject?._id), 
                                                        // activeStep={activeStep}
                                                        // setActiveStep={setActiveStep}
                                                        setStreamingMessages: setStreamingMessages, isUserOnboarded: isUserOnboarded, setIsUserOnboarded: setIsUserOnboarded }) }) }) }) })] })] }) }) }), _jsx(ProjectSelectionDialog, { visible: showProjectSelectionDialog, setProjectIdFromURL: setProjectIdFromURL, onHide: () => setShowProjectSelectionDialog(false), triggerForPersist: triggerForPersist, setPersistedData: setPersistedData, parentRef: modeSideRef, msgDataArtifact: msgDataArtifact, setMsgDataArtifact: setMsgDataArtifact }), projectAccess && projectAccess === "denied" &&
                (_jsx(AccessDeniedDialog, { visible: true, 
                    // onHide={() => setShowAccessDeniedDialog(false)}
                    onHide: () => { } })), invalidProject && invalidProject === "invalid" && (_jsx(InvalidProjectDialog, { visible: true, onHide: () => { }, onRequestAccess: () => {
                    window.location.href = "/chat?newChat=true";
                } }))] }));
}
export default AppLayout;
